import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "hyphenationstyleenum"
    }}>{`HyphenationStyleEnum`}</h1>
    <p>{`Provider hyphenation styles. Currently only supported by the Duden hyphenation provider.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HYPH_ALL`}</strong>{` = 1684106348`}</p>
      <p parentName="blockquote">{`Hyphenates at all possible hyphenation points.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HYPH_ALL_BUT_UNAESTHETIC`}</strong>{` = 1684103797`}</p>
      <p parentName="blockquote">{`Hyphenates at all but unaesthetic hyphenation points.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HYPH_AESTHETIC`}</strong>{` = 1684104563`}</p>
      <p parentName="blockquote">{`Hyphenates at aesthetic hyphenation points.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HYPH_PREFERRED_AESTHETIC`}</strong>{` = 1685086565`}</p>
      <p parentName="blockquote">{`Hyphenates at preferred aesthetic hyphenation points.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      